'use client';

import type { SendDataPayload } from '@/lib/services/collection/workflow-hooks';
import {
  SendStep,
  type SendStepConfig,
  type SendStepInitialData,
  type SendStepResults
} from '../../_shared/send-step';

const COLLECTION_CONFIG: SendStepConfig = {
  correspondenceType: 'collection-request',
  loadingMessage: 'Preparing collection requests...',
  draftErrorMessage: 'Failed to prepare notifications. Please try again.',
  sendAllButtonLabel: 'Send All Collection Requests',
  resultsItemLabel: 'collection requests',
  nothingToSendMessage:
    'No correspondences to send. All are marked as post only or pending research',
  header: {
    title: (count) =>
      `${count} ${count === 1 ? 'institution' : 'institutions'} ready`,
    description:
      'Review and send collection requests individually or all at once'
  },
  supportsPostOnly: true
};

interface SendCollectionStepProps {
  initialData?: SendStepInitialData;
  /** Required — see `SendStepProps.onSend` (VALE-546). */
  onSend: (data: SendDataPayload) => void | Promise<unknown>;
  onRefreshCorrespondences?: () => Promise<void>;
  isSending?: boolean;
  sendResults?: SendStepResults;
  matterId: number;
}

export function SendCollectionStep(props: SendCollectionStepProps) {
  return <SendStep<SendDataPayload> config={COLLECTION_CONFIG} {...props} />;
}
